<template>
    <footer>
        <div class="container-fluid" style="background: #F8FAFD;">
            <div class="container" style="background: #F8FAFD;">
            
            <div class="row p-4">
                <div class="col-md-4 mb-3">
                    <div v-if="total_visitor > 0">
                        <h5>
                            <b>Pengunjung Website</b>
                        </h5>
                    </div>
                    <div v-else>
                        <ContentLoader width="100%" height="20px"/>
                    </div>

                    <hr/>

                    <div v-if="total_visitor > 0">
                        <table class="w-100" align="center">
                            <tr>
                                <td style="width: 40%;">Hari Ini</td>
                                <td style="width: 5%;">:</td>
                                <td>{{ visit_now }} Kunjungan</td>
                            </tr>
                            <tr>
                                <td>Bulan Ini</td>
                                <td>:</td>
                                <td>{{ visit_now_m }} Kunjungan</td>
                            </tr>
                            <tr>
                                <td>Bulan Lalu</td>
                                <td>:</td>
                                <td>{{ visit_last_m }} Kunjungan</td>
                            </tr>
                            <tr>
                                <td>Total Kunjungan</td>
                                <td>:</td>
                                <td>{{ total_visitor }} Kunjungan</td>
                            </tr>
                        </table>
                    </div>

                    <div v-else>
                        <div class="row">
                            <ListLoader viewBox="0 0 275 20" /><br/>
                            <ListLoader viewBox="0 0 275 20" /><br/>
                            <ListLoader viewBox="0 0 275 20" /><br/>
                            <ListLoader viewBox="0 0 275 20" /><br/>
                        </div>
                    </div>
                    <br/>
                </div>

                <div class="col-md-4 mb-3">
                    <div v-if="kategoris.length > 0">
                        <h5 id="kategoriberita">
                            <b>Kategori Berita</b>
                        </h5>
                    </div>
                    <div v-else>
                        <ContentLoader width="100%" height="20px"/>
                    </div>

                    <hr/>
                    
                    <div v-if="kategoris.length > 0">
                        <div class="list-group">
                            <ul class="no-bullets">
                                <li v-for="kategori in kategoris" :key="kategori.id">
                                <!-- <router-link :to="{name: 'kategori_berita', params:{id: kategori.id}}" class="text-decoration-none text-dark"
                                v-for="kategori in kategoris" :key="kategori.id" target="_blank"> {{ kategori.kategori_nama }}<br/>
                                </router-link> -->
                                <a :href="$router.resolve({name: 'Kategori Berita', params:{id: kategori.id}}).href" class="text-decoration-none text-dark"> 
                                    {{ kategori.kategori_nama }}
                                </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-else>
                        <div class="row">
                            <div v-for="loader in kategoris_loader" :key="loader">
                                <BulletListLoader viewBox="0 0 340 100" />                                
                            </div>
                        </div>
                    </div>
                    <br/>
                </div>

                <div class="col-md-4 mb-2">
                    <div v-if="webconfigs.length > 0">
                        <h5 v-for="webconfig in webconfigs" :key="webconfig.id">
                            <b>{{ webconfig.nama_web }}</b>
                        </h5>
                    </div>
                    <div v-else>
                        <ContentLoader width="100%" height="20px"/>
                    </div>
                    
                    <hr/>

                    <div v-if="webconfigs.length > 0">
                        <p style="text-align: justify;" v-for="webconfig in webconfigs" :key="webconfig.id">
                            {{ webconfig.deskripsi }}
                        </p>
                    </div>
                    <div v-else>
                        <ListLoader viewBox="0 0 275 60" />
                    </div>
                    
                    <br/>
                    <!-- <div>
                        <ul class="d-flex flex-row ms-n3 nav">
                            <li class="nav-item" >
                                <a class="pe-2" href="#" target="_blank">
                                    <i class="fab fa-facebook opacity-8" style="color:#344767; font-size:1.8em"></i>
                                </a>
                            </li>
                            <li class="nav-item" >
                                <a class="pe-2" href="https://www.instagram.com/setda_kotabogor/" target="_blank">
                                    <i class="fab fa-instagram opacity-8" style="color:#344767; font-size:1.8em"></i>
                                </a>
                            </li>
                            <li class="nav-item" >
                                <a class="pe-2" href="https://www.youtube.com/channel/UCzNZZjRjl104MvsAxGV8jMw" target="_blank">
                                    <i class="fab fa-youtube opacity-8" style="color:#344767; font-size:1.8em"></i>
                                </a>
                            </li>
                        </ul>
                    </div> -->
                    <!-- Copyright © 2022 Dinas Komunikasi dan Informatika Kota Bogor. All rights reserved.<br/><br/> -->
                    <div v-if="webconfigs.length > 0">
                        <h5 v-for="webconfig in webconfigs" :key="webconfig.id">
                            <b>Kontak Kami</b>
                        </h5>
                    </div>
                    <div v-else>
                        <ContentLoader width="100%" height="20px"/>
                    </div>

                    <hr/>

                    <div v-if="webconfigs.length > 0">
                        <div v-for="webconfig in webconfigs" :key="webconfig.id">
                            <p>
                                Alamat Kantor :<br/>
                                <i class="fa fa-map-marker" aria-hidden="true"></i> 
                                {{ webconfig.alamat }}<br/><br/>
                                
                                Email : <br/>
                                <i class="fa fa-envelope"></i> 
                                {{ webconfig.email }}<br/><br/>
                                
                                Telepon | Fax : <br/>
                                <i class="fa fa-phone"></i> 
                                {{ webconfig.telp }}
                                
                                <font class="mx-1"> | </font> 
                                
                                <i class="fa fa-fax"></i> 
                                {{ webconfig.fax }}<br/>
                            </p>

                            <div>
                                Media Sosial :
                                <ul class="d-flex flex-row ms-n3 nav">
                                    <!-- <li class="nav-item" >
                                        <a class="pe-2" href="#" target="_blank">
                                            <i class="fab fa-facebook opacity-8" style="color:#344767; font-size:1.8em"></i>
                                        </a>
                                    </li> -->
                                    <!-- <li class="nav-item" >
                                        <a class="pe-2" href="https://twitter.com/bpkadkotabogor" target="_blank">
                                            <i class="fab fa-twitter opacity-8" style="color:#344767; font-size:1.8em"></i>
                                        </a>
                                    </li>
                                    <li class="nav-item" >
                                        <a class="pe-2" href="https://www.instagram.com/bkadkotabogor/" target="_blank">
                                            <i class="fab fa-instagram opacity-8" style="color:#344767; font-size:1.8em"></i>
                                        </a>
                                    </li>
                                    <li class="nav-item" >
                                        <a class="pe-2" href="#" target="_blank">
                                            <i class="fab fa-youtube opacity-8" style="color:#344767; font-size:1.8em"></i>
                                        </a>
                                    </li> -->
                                    <p style="line-height:30px">
                                        <a v-if="webconfig.fb != NULL" 
                                            class="text-decoration-none text-muted" 
                                            :href="webconfig.url_fb" 
                                            target="_blank">
                                            
                                            <i class="fab fa-facebook opacity-8" style="color:#344767; font-size:1.5em;"></i> {{ webconfig.fb }}
                                            <br/>
                                        </a>
                                        <a v-if="webconfig.twitter != NULL" 
                                            class="text-decoration-none text-muted" 
                                            :href="webconfig.url_twitter" 
                                            target="_blank">
                                            
                                            <i class="fab fa-twitter opacity-8" style="color:#344767; font-size:1.5em;"></i> @{{ webconfig.twitter }}
                                            <br/>
                                        </a>
                                        <a v-if="webconfig.ig != NULL" 
                                            class="text-decoration-none text-muted" 
                                            :href="webconfig.url_ig" 
                                            target="_blank">
                                            
                                            <i class="fab fa-instagram opacity-8" style="color:#344767; font-size:1.5em;"></i> @{{ webconfig.ig }}
                                            <br/>
                                        </a>
                                        <a v-if="webconfig.youtube != NULL" 
                                            class="text-decoration-none text-muted" 
                                            :href="webconfig.url_youtube" 
                                            target="_blank">
                                            
                                            <i class="fab fa-youtube opacity-8" style="color:#344767; font-size:1.5em;"></i> {{ webconfig.youtube }}
                                            <br/>
                                        </a>
                                    </p>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div v-else>
                        <div>
                            <ListLoader viewBox="0 0 300 30" /><br/><br/>
                        </div>
                        <div>
                            <ListLoader viewBox="0 0 300 30" /><br/><br/>
                        </div>
                        <div>
                            <ListLoader viewBox="0 0 300 30" /><br/><br/>
                        </div>
                        <div>
                            <ListLoader viewBox="0 0 300 30" /><br/><br/>
                        </div>
                    </div>
                    
                </div>
            </div>
            </div>
        </div>
        <div class="container-fluid" style="background-color: #161616;">
            <div class="row p-2">
                <div class="text-center text-white font-weight-bold" style="font-size:1.1em;">
                    Copyright © 2023 Dinas Komunikasi dan Informatika Kota Bogor. All rights reserved.
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    //import content loader
    import {
        BulletListLoader, ContentLoader, ListLoader
    } from 'vue-content-loader';

    //import axios
    import axios from 'axios';

    //import moment
    import moment from 'moment';

    // import 'bootstrap/dist/css/bootstrap.css'

    //import hook onMounted from vue
    import { ref, onMounted } from 'vue';

    export default {
        name: 'FooterComponent',

        components: {
            //loader component
            BulletListLoader,
            ContentLoader,
            ListLoader
        },

        methods: {
            dateNow() {
                return moment().locale('id').format('YYYY');
            },
        },
        
        setup() {
            
            //define state
            const kategoris = ref([]);
            const kategoris_loader = ref(1);

            const webconfigs = ref([]);
            const webconfigs_loader = ref(1);

            const visit_now = ref([]);
            const visit_now_m = ref([]);
            const visit_last_m = ref([]);
            const total_visitor = ref([]);

            //on mounted
            onMounted(() => {
                //get kategori berita
                axios.get('/api/kategori/berita')
                    .then(response => {
                        kategoris.value = response.data.data;
                    })

                //get konfigurasi web
                axios.get('/api/webconfig')
                    .then(response => {
                        webconfigs.value = response.data.data;
                    })

                //get visitor
                axios.get('/api/visitor')
                    .then(response => {
                        visit_now.value     = response.data.hari_ini;
                        visit_now_m.value   = response.data.bulan_ini;
                        visit_last_m.value  = response.data.bulan_lalu;
                        total_visitor.value = response.data.total_kunjungan;
                    })
            });

            //return data
            return {
                kategoris,
                kategoris_loader,
                webconfigs,
                webconfigs_loader,
                visit_now,
                visit_now_m,
                visit_last_m,
                total_visitor
            }
        }
    }
</script>